import { h } from 'preact';
import { CopyButton } from '../CopyButton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'CopyButton',
  category: '🔘 Botões',
  description: 'Botão que copia texto para o clipboard com feedback visual',
  usedIn: ['Integrations', 'Profile', 'AgentesPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      <CopyButton text="ert_live_abc123xyz" label="Copiar Token" />
      <CopyButton text="npm install example-pkg" size="sm" />
    </div>
  ),
};
